import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { DepartmentData } from '../../../../@core/interfaces/masters/department';
import { PhysicianData } from '../../../../@core/interfaces/masters/physician-mst';
import { RolesData } from '../../../../@core/interfaces/common/roles';
import { QcReasonMstData } from '../../../../pages/inventory/backend-module/interface/master/qcreason-mst';
import { ToastrAppSrvcService } from '../../../../_services/toastr-app-srvc.service';
import { environment } from '../../../../../environments/environment';
import { DateService } from '../../../../@theme/components/common/service/date.service';
export interface ErReferralRequest {
  departmentId: string;
  doctorId?: string;
  priority: string;
  reason: string;
  patientId: string;
  visitId: string;
  doctorType?: string;
}

@Component({
  selector: 'ngx-er-request-referral',
  templateUrl: './er-request-referral.component.html',
  styleUrls: ['./er-request-referral.component.scss'],
})
export class ErRequestReferralComponent implements OnInit, OnDestroy {
  @Input() referralId: number | null = null;
  @Input() patientId = '';
  @Input() visitId = '';
  @Input() regId: any;
  @Input() admissionId: any;
  @Input() rootId: number | any;
  @Input() caseSheetViewSummary: any = {};
  @Input() editPatApt: any = {};
  @Input() visitLog: Array<any> = [];
  @Input() lineData: any;
  @Input() initialReferral: Partial<ErReferralRequest> | null = null;
  @Input() reRefralId: any;
  @Input() isFromRerefral: boolean = false;
  @Input() refDocId: any;
  @Output() referralSubmit = new EventEmitter<ErReferralRequest>();
  @Output() referralSaved = new EventEmitter<any>();

  referralForm: FormGroup | any;
  isEditMode = false;
  isSubmitting = false;
  submitSuccess = false;
  editPcId: number | null = null;
  appListData: Array<any> = [];

  departmentList: any[] = [];
  internalDoctors: any[] = [];
  externalDoctors: any[] = [];
  filteredDoctors: any[] = [];

  priorityList = [
    { value: 'Routine', label: 'Routine' },
    { value: 'Urgent', label: 'Urgent' },
    { value: 'Emergency', label: 'Emergency' },
  ];

  doctorTypeList = [
    { value: 'Inhouse', label: 'Internal' },
    { value: 'External', label: 'External' },
  ];

  private tenantId = localStorage.getItem('tenantId');
  private branchId = localStorage.getItem('branchId');
  private userId = localStorage.getItem('userId');
  protected readonly unsubscribe$ = new Subject<void>();
  get apiUrl(): string { return environment.apiUrl; }

  constructor(
    private fb: FormBuilder,
    private deptSrvc: DepartmentData,
    private DateService: DateService,
    private phySrvc: PhysicianData,
    private rolesService: RolesData,
    private qcReasonMstData: QcReasonMstData,
    private toaster: ToastrAppSrvcService,
  ) { }

  ngOnInit(): void {
    this.buildForm();
    this.loadDepartments();
    this.loadDoctors();
    console.info(this.lineData, 'lineData in referral component');
    if (this.referralId || this.initialReferral) {
      this.isEditMode = true;
      this.referralForm.patchValue(this.initialReferral || {});
      this.onDepartmentChange(this.referralForm.get('departmentId')?.value);
    }
    this.TaskOrder();
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  private buildForm(): void {
    this.referralForm = this.fb.group({
      departmentId: [null, Validators.required],
      doctorId: [null, Validators.required],
      doctorType: ['Inhouse'],
      priority: ['Routine', Validators.required],
      reason: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(500)]],
    });
  }

  private loadDepartments(): void {
    this.deptSrvc.list(`${this.tenantId}/departments/getDepartmentMaster?branchId=${this.branchId}`)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((data: any) => {
        this.departmentList = (data?.details || []).filter(
          (x: any) => x.isActive == true && x.isClinical == 'true',
        );
      });
  }

  private loadDoctors(): void {
    this.phySrvc.list(`physicians/${this.tenantId}/${this.branchId}/GetAllInternalDoctor`)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((data: any) => {
        this.internalDoctors = data || [];
        this.applyDoctorFilter();
      });

    this.phySrvc.list(`physicians/${this.tenantId}/${this.branchId}/GetAllExternalDoctor`)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((data: any) => {
        this.externalDoctors = data || [];
        this.applyDoctorFilter();
      });
  }

  get departmentId() { return this.referralForm.get('departmentId'); }
  get doctorId() { return this.referralForm.get('doctorId'); }
  get doctorType() { return this.referralForm.get('doctorType'); }
  get priority() { return this.referralForm.get('priority'); }
  get reason() { return this.referralForm.get('reason'); }

  onDepartmentSelectionChange(event: any): void {
    const departmentId = event?.[0]?.value || event?.[0]?.data?.id || event?.value || null;
    this.onDepartmentChange(departmentId);
  }

  onDepartmentChange(departmentId: any): void {
    this.referralForm.patchValue({ doctorId: null });
    this.applyDoctorFilter(departmentId);
  }

  onDoctorTypeChange(): void {
    this.referralForm.patchValue({ doctorId: null });
    this.applyDoctorFilter();
  }

  private applyDoctorFilter(deptIdOverride?: any): void {
    const type = this.doctorType?.value || 'Inhouse';
    const source = type === 'External' ? this.externalDoctors : this.internalDoctors;
    const deptId = deptIdOverride !== undefined ? deptIdOverride : this.departmentId?.value;

    if (!deptId) {
      this.filteredDoctors = [...source.filter((doctor: any) => doctor.id != this.lineData.visitDoctorid)];
      return;
    }

    this.filteredDoctors = source.filter((doctor: any) => doctor.departmentId == deptId && doctor?.id !== this.refDocId);
  }

  onSubmit(): void {
    if (this.referralForm.invalid) {
      this.referralForm.markAllAsTouched();
      this.toaster.ForDanger('Please Fill Mandatory Fields');
      return;
    }
    if (this.isSubmitting) return;

    if (this.editPcId) {
      this.callUpdate();
    } else {
      this.callSave();
    }

    const payload: ErReferralRequest = {
      ...this.referralForm.value,
      patientId: this.patientId || this.regId,
      visitId: this.visitId,
    };
    this.referralSubmit.emit(payload);
  }

  private buildInputJson(): any {
    const f = this.referralForm.value;
    const docData = this.filteredDoctors.find((x: any) => x?.id == f.doctorId)
      || this.internalDoctors.find((x: any) => x?.id == f.doctorId)
      || this.externalDoctors.find((x: any) => x?.id == f.doctorId);

    return {
      Reason: f.reason,
      Type: f.doctorType || 'Inhouse',
      Mode: null,
      Doctor: f.doctorId,
      Admissionperiod: null,
      DateTime: null,
      Scheduled: 'New',
      Insurance: null,
      Priority: f.priority,
      oldApp: this.visitLog?.[0]?.appointmentId,
      refDoc: this.caseSheetViewSummary?.opvisit?.length > 0
        ? this.caseSheetViewSummary?.opvisit[0]?.name
        : this.editPatApt?.department?.name || '-',
      refDep: this.caseSheetViewSummary?.opvisit?.length > 0
        ? this.caseSheetViewSummary?.opvisit[0]?.depname
        : this.editPatApt?.doctor?.displayName || '-',
      docName: docData?.displayName || docData?.name || '-',
      docid: docData?.id || '-',
      depid: docData?.department?.id || f.departmentId || '-',
      deptName: docData?.department?.name || '-',

    };
  }

  private buildBasePayload(): any {
    const f = this.referralForm.value;
    return {
      woId: null,
      regId: this.regId || this.patientId,
      ipId: this.admissionId,
      careTaskType: 14,
      careTaskPlace: null,
      careTaskStatus: 4,
      TenantId: this.tenantId,
      BranchId: this.branchId,
      CreatedIP: null,
      UpdatedIP: null,
      inputJson: JSON.stringify(this.buildInputJson()),
      visitId: this.visitId,
      SubstatusName: 'SecondOpinion-RefAppointment',
      doctorId: f.doctorId,
      rootId: this.rootId ? this.rootId : null,
    };
  }

  private callSave(): void {
    this.isSubmitting = true;
    const postData = {
      ...this.buildBasePayload(),
      CreatedDate: new Date(),
      CreatedBy: this.userId,
      UpdatedDate: null,
      UpdatedBy: null,
      RereferralId: this.reRefralId,
    };

    this.rolesService.create(`${this.apiUrl}/PatientCareTaskMaster/PostPatientCareTaskMst`, postData)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((data: any) => {
        this.isSubmitting = false;
        this.submitSuccess = true;
        this.toaster.ForSuccess('Data saved Successfully');
        this.referralSaved.emit(data?.details);
        this.appListData = data.details.map((item: any) => ({
          ...item,
          createdDate : this.DateService.dateUtctoLocalDateAndTime(item.createdDate),
          parsedData: JSON.parse(item.inputJson || '{}')
        }));
        this.onReset();
      }, () => {
        this.isSubmitting = false;
        this.toaster.ForDanger('Failed to save referral');
      });
  }

  private callUpdate(): void {
    this.isSubmitting = true;
    const putData = {
      ...this.buildBasePayload(),
      pcId: this.editPcId,
      CreatedDate: this.createdDate,
      CreatedBy: this.createdBy,
      UpdatedDate: new Date(),
      UpdatedBy: this.userId,
    };

    this.rolesService.update(`${this.apiUrl}/PatientCareTaskMaster/UpdatePatientCareTaskMst/${this.editPcId}`, putData)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((data: any) => {
        this.isSubmitting = false;
        this.submitSuccess = true;
        this.toaster.ForSuccess('Data Updated Successfully');
        this.referralSaved.emit(data?.details);
        this.editPcId = null;
        this.isEditMode = false;
        this.TaskOrder();
        this.onReset();
      }, () => {
        this.isSubmitting = false;
        this.toaster.ForDanger('Failed to update referral');
      });
  }

  TaskOrder() {
    this.rolesService.list(`PatientCareTaskMaster/GetPatientCareTaskMaster?tenantId=${this.tenantId}&branchId=${this.branchId}&visitId=${this.visitId}`)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((data: any) => {
        this.appListData = (data?.details?.filter((x: any) => x?.careTaskType == 14) || []).map((item: any) => ({
          ...item,
          createdDate : this.DateService.dateUtctoLocalDateAndTime(item.createdDate),
          parsedData: JSON.parse(item.inputJson || '{}'),
        }));
      });
  }
  createdDate:any
  createdBy:any
  editReferralItem(item: any): void {
    this.createdDate = item?.createdDate;
    this.createdBy = item?.createdBy;
    if (!item) return;
    this.loadReferral({ pcId: item.pcId, ...item.parsedData });
  }

  loadReferral(record: any): void {
    if (!record) return;
    this.editPcId = record.pcId || null;
    this.isEditMode = !!this.editPcId;

    this.referralForm.patchValue({
      doctorType: record.Type || 'Inhouse',
      doctorId: record.Doctor,
      priority: record.Priority || 'Routine',
      reason: record.Reason,
      departmentId: record.depid || null,
    });
    this.applyDoctorFilter();
  }

  onReset(): void {
    this.referralForm.reset({ priority: 'Routine', doctorType: 'Inhouse' });
    this.filteredDoctors = [...this.internalDoctors];
    this.editPcId = null;
    this.isEditMode = false;
    setTimeout(() => { this.submitSuccess = false; }, 3000);

  }
}
